import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, ListGroup, Image, Card } from 'react-bootstrap';
import Message from '../components/Message';
import Loader from '../components/Loader';
import { useGetDailyStoreStockDetailsQuery } from '../slices/dailyStoreStocksApiSlice';

const DailyStoreStockScreen = () => {
  const { id: dailyStoreStockId } = useParams();

  const { data: dailyStoreStock, refetch, isLoading, error } = useGetDailyStoreStockDetailsQuery(dailyStoreStockId);

  useEffect(() => {
    if (!dailyStoreStock) {
      refetch();
    }
  }, [dailyStoreStock, refetch]);

  return isLoading ? (
    <Loader />
  ) : error ? (
    <Message variant="danger">{error?.data?.message || error.error}</Message>
  ) : (
    <>
      <h1>DailyStoreStock {dailyStoreStock?._id || 'N/A'}</h1>
      <Row>
        <Col md={8}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h2>Customer Details</h2>
              <p>
                <strong>Name: </strong> {dailyStoreStock?.customerDetails?.name || 'N/A'}
              </p>
              <p>
                <strong>Company: </strong> {dailyStoreStock?.customerDetails?.company || 'N/A'}
              </p>
              <p>
                <strong>Phone: </strong> {dailyStoreStock?.customerDetails?.telephone || 'N/A'}
              </p>
              <p>
                <strong>Address: </strong> {dailyStoreStock?.customerDetails?.address || 'N/A'}
              </p>
              <p>
                <strong>Serial: </strong> {dailyStoreStock?.customerDetails?.serialNumber || 'N/A'}
              </p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>DailyStoreStock Note</h2>
              <p>{dailyStoreStock?.note || 'No additional notes provided'}</p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>DailyStoreStock Items</h2>
              {dailyStoreStock?.dailyStoreStockItems?.length === 0 ? (
                <Message>This dailyStoreStock has no items</Message>
              ) : (
                <ListGroup variant="flush">
                  {dailyStoreStock?.dailyStoreStockItems?.map((item, index) => (
                    <ListGroup.Item key={index}>
                      <Row>
                        <Col md={1}>
                          <Image
                            src={item?.images?.[0] || 'https://via.placeholder.com/40'}
                            alt={item?.name || 'Unnamed'}
                            fluid
                            rounded
                          />
                        </Col>
                        <Col>
                          <strong>{item?.name || 'Unnamed'}</strong>
                        </Col>
                        <Col md={4}>
                          {item?.qty || 0} x ${item?.price || 0} = D
                          {(item?.qty || 0) * (item?.price || 0)}
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={4}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <h2>DailyStoreStock Summary</h2>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Date</Col>
                  <Col>{dailyStoreStock?.date?.substring(0, 10) || 'N/A'}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Total</Col>
                  <Col>D{dailyStoreStock?.totalPrice || 0}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Status</Col>
                  <Col>{dailyStoreStock?.status || 'N/A'}</Col>
                  <Col>{dailyStoreStock?.username || 'No user name provided'}</Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default DailyStoreStockScreen;